import React, { useState, useEffect, useRef } from "react";
import "./modal.css";
import Localize from "../../components/Localize/Localize";

const TextInputModal = ({ title = "", initialValue = "", idTask, type = "text", maxLength = -1, onClose }) => {
    const [value, setValue] = useState(initialValue);
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const inputRef = useRef(null);

    useEffect(() => {
        const input = inputRef.current;
        if (input) {
            input.focus();
            setTimeout(() => {
                input.setSelectionRange(input.value.length, input.value.length);
                input.click();
            }, 100);
        }
    }, []);

    const validate = (val) => {
        if (maxLength > 0 && val.length > maxLength) return `Max length is ${maxLength}`;
        if (type === "number" && /[^0-9]/.test(val)) return "Only numbers are allowed.";
        return "";
    };

    const handleChange = (e) => {
        let val = e.target.value;

        if (type === "number") {
            val = val.replace(/[^0-9]/g, "");
        }

        if (maxLength > 0) {
            val = val.slice(0, maxLength);
        }

        setValue(val);
        if (error) setError("");
    };

    const submit = () => {
        const validationError = validate(value);
        if (validationError) {
            setError(validationError);
            return;
        }

        const iframe = document.getElementById("game-iframe");
        iframe?.contentWindow?.postMessage(
            { action: "submitFormModal", idTask, value },
            "*"
        );
        onClose();
    };

    const cancel = () => {
        const iframe = document.getElementById("game-iframe");
        iframe?.contentWindow?.postMessage(
            { action: "submitFormModal", idTask, value: null },
            "*"
        );
        onClose();
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            submit();
        }
    };

    const inputType = type === "password" && !showPassword ? "password" : type === "number" ? "tel" : "text";

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>{Localize.translate(title)}</h2>
                <div className="input-wrapper">
                    <input
                        ref={inputRef}
                        type={inputType}
                        value={value}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        inputMode={type === "number" ? "numeric" : undefined}
                        {...(maxLength > 0 ? { maxLength } : {})}
                    />
                    {type === "password" && (
                        <button
                            className="toggle-password-button"
                            onClick={() => setShowPassword((prev) => !prev)}
                            aria-label="Toggle password visibility"
                        >
                            <i className={`bi ${showPassword ? "bi-eye-slash-fill" : "bi-eye-fill"}`}></i>
                        </button>
                    )}
                </div>

                {error && <p className="error-message">{error}</p>}

                <div className="modal-buttons">
                    <button className="primary" onClick={submit}>OK</button>
                </div>
            </div>
        </div>
    );
};

export default TextInputModal;
